const coffeeData = [
  {
    id: 1,
    name: "Hot Coffee",
    price: 120,
    image: "/images/hot.jpg"
  },
  {
    id: 2,
    name: "Iced Coffee",
    price: 150,
    image: "/images/iced.jpg"
  },
  {
    id: 3,
    name: "Cappuccino",
    price: 180,
    image: "/images/cappuccino.jpg"
  },
  {
    id: 4,
    name: "Latte",
    price: 170,
    image: "/images/latte.jpg"
  },
  {
    id: 5,
    name: "Mocha",
    price: 190,
    image: "/images/mocha.jpg"
  }
];

export default coffeeData;